import { render, staticRenderFns } from "./DosageForm.vue?vue&type=template&id=4c414f67&scoped=true"
import script from "./DosageForm.vue?vue&type=script&lang=js"
export * from "./DosageForm.vue?vue&type=script&lang=js"
import style0 from "./DosageForm.vue?vue&type=style&index=0&id=4c414f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c414f67",
  null
  
)

export default component.exports